const version = process.env.REACT_APP_VERSION ?? "0.0.0";
const suffix = process.env.REACT_APP_VERSION_SUFFIX ?? "Et-PROD";

function environmentLabel(value: string): string {
  const normalized = value.toUpperCase();
  if (normalized.endsWith("DEV")) return "DEV";
  if (normalized.endsWith("PROD")) return "PROD";
  return value;
}

/** Texto visible: "PROD 1.3.1" */
export const appVersionDisplay = `${environmentLabel(suffix)} ${version}`;
